import React, { FC, useState, useEffect } from 'react'
import { Box, Button, Radio, Text, VStack } from '@chakra-ui/react'
import theme from '../../styles'
import { Icon } from '../icon'
import { useSelector } from 'react-redux'
import { selectScenario, selectCurrentStep } from '../../state'
import { ScenarioType, Steps } from '../../state/interfaces'
import { useTranslation } from 'react-i18next'
import { LeadPlanInfo } from '../miscelanea/lead-plan-info'

export interface SelectProps {
  onChange?: (values: string[]) => void
  placeholder?: string
}

export const RadioConfirm: FC<SelectProps> = ({ onChange, placeholder }) => {
  const [radioValue, setRadioValue] = useState('no')
  const scenario = useSelector(selectScenario)
  const currentStep = useSelector(selectCurrentStep)
  const shouldDisplayTextInstead =
    scenario?.type === ScenarioType.FIBER_OPTIC_ALERT && currentStep?.id === Steps.CONFIRM_FIBER_OPTIC_ALERT
  const { t } = useTranslation()

  useEffect(() => {
    if (shouldDisplayTextInstead) {
      setRadioValue('yes')
    }
  }, [shouldDisplayTextInstead])

  return (
    <VStack spacing={3} marginY={8} width="100%" gridRowGap={4}>
      {currentStep!.id === Steps.CONFIRM_LEAD && <LeadPlanInfo />}
      <Box
        as="label"
        border="2px solid"
        borderColor="grey"
        fontWeight="bold"
        borderRadius="lg"
        padding={4}
        maxWidth={450}
        _hover={{
          borderColor: 'brand',
        }}
      >
        <Radio
          name="confirm-answers"
          value={radioValue}
          fontSize="xs"
          size="lg"
          color="grey"
          border="4px"
          onChange={() => setRadioValue('yes')}
          isChecked={radioValue === 'yes'}
          _checked={{
            backgroundColor: 'brand',
          }}
          _focus={{
            borderColor: 'brand',
            boxShadow: '0 0 0 2px #5bce4c',
          }}
        >
          <Box cursor="pointer">{placeholder}</Box>
        </Radio>
      </Box>
      {radioValue === 'yes' &&
        (shouldDisplayTextInstead ? (
          <Button
            role={'button'}
            layerStyle={theme.LayerStyles.SMALL_PILL}
            onClick={() => {
              onChange && onChange([radioValue])
            }}
            _focus={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
              transform: 'scale(1.05)',
            }}
            _hover={{
              transform: 'scale(1.05)',
            }}
            borderColor="brand"
            tabIndex={0}
          >
            <Text color="white" fontSize={20} fontWeight="bold">
              {' '}
              {t('fiber-optic_btn')}{' '}
            </Text>
          </Button>
        ) : (
          <Button
            role={'button'}
            layerStyle={theme.LayerStyles.SMALL_PILL}
            onClick={() => {
              onChange && onChange([radioValue])
            }}
            _focus={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
              transform: 'scale(1.05)',
            }}
            _hover={{
              transform: 'scale(1.05)',
            }}
            borderColor="brand"
            tabIndex={0}
          >
            <Icon icon="arrow-right" color="white" />
          </Button>
        ))}
    </VStack>
  )
}
